import React, { useRef } from 'react';
import {
  Stack,
  Text,
  DefaultButton,
  Image,
  IStackTokens,
  IComboBoxOption,
  Label,
  Icon,
} from '@fluentui/react';
import { AppContext } from '../AppInRouterContext';
import { useParams } from 'react-router-dom';

interface IConfirmacionRegistro {
  appContext: AppContext;
}

export const checkMaxSize = (sizeInBytes: number) => {
  const limit = 20 * 1024 * 1024; // 50MB
  return sizeInBytes < limit;
};

const outerStackTokens: IStackTokens = { childrenGap: 20 };
const bodyStackTokens: IStackTokens = { childrenGap: 10 };

export const ConfirmacionRegistro = (props: IConfirmacionRegistro) => {

  const [registracionConfirmada, setRegistracionConfirmada] = React.useState<boolean | null>(null);
  const [registracionYaRealizada, setRegistracionYaRealizada] = React.useState<boolean | null>(null);

  const { token } = useParams();

  const confirmarRegistracion = async () => {
    try {
      props.appContext.changeBlockUI(true);
      const ret = await props.appContext.system.getRegistroEntrenadorSystem().confirmarRegistracion(token!);
      console.log(ret)
      if (ret.statusCode && ret.statusCode === 200) {
        setRegistracionConfirmada(true);
      } else if (ret.statusCode && ret.statusCode === 208) {
        setRegistracionYaRealizada(true);
      } else {
        setRegistracionConfirmada(false);
      }
    } catch (err) {
      setRegistracionConfirmada(false);
      props.appContext.courier.messageError(err);
    } finally {
      props.appContext.changeBlockUI(false);
    }

  };

  React.useEffect(() => {
    confirmarRegistracion();
  }, [])

  const getBody = () => {
    console.log('get body')
    console.log(registracionConfirmada, 'reg conf')
    if (registracionConfirmada === null && registracionYaRealizada === null) {
      return (
        <Stack horizontal horizontalAlign="center" verticalAlign="center" tokens={{ childrenGap: 10 }}>
          <Icon iconName="Sync" style={{ fontSize: 20, animation: 'spin 2s linear infinite' }} />
        </Stack>
      );
    } else if (registracionConfirmada) {
      return <div className="text-center">
        <div>
          <Icon iconName="SkypeCircleCheck" style={{ fontSize: 100, color: '#107C10' }}></Icon>
        </div>
        <div className="mt-2">
          <Text block variant="xLarge">
            ¡Registración confirmada!
          </Text>
          <Text block className="mt-2" variant="large">
            En breves estaremos revisando tu solicitud y te habilitaremos.
          </Text>
        </div>
      </div>;
    } else if (registracionYaRealizada) {
      return <div className="text-center">
        <div>
          <Icon iconName="SkypeCircleCheck" style={{ fontSize: 100, color: '#107C10' }}></Icon>
        </div>
        <div className="mt-2">
          <Text block variant="xLarge">
            La registración ya fue confirmada previamente.
          </Text>
          <Text block className="mt-2" variant="large">
            En breves estaremos revisando tu solicitud y te habilitaremos.
          </Text>
        </div>
      </div>;
    } else {
      return <div className="text-center">
        <div>
          <Icon iconName="Cancel" style={{ fontSize: 100, color: '#C00' }}></Icon>
        </div>
        <div className="mt-2">
          <Text block variant="xLarge">
            Error al confirmar tu registración.
          </Text>
          <Text block className="mt-2" variant="large">
            Contactate con tu supervisor para resolver el problema.
          </Text>
        </div>
      </div>;
    }
  };

  return (
    <Stack
      verticalAlign="center"
      horizontalAlign="center"
      styles={{
        root: {
          height: '100vh',
          width: '100vw',
          backgroundColor: 'white', // Color de fondo para todo el contenedor
          color: 'white !important',
          justifyContent: 'normal',
        },
      }}
    >
      <Stack
        tokens={outerStackTokens}
        styles={{
          root: {
            width: 370,
            // height: 550,
            // boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
            // borderRadius: 8,
            padding: 10,
            // backgroundColor: '#ffffff',
          },
        }}
      >
        {/* Logo */}
        <Image
          height={80}
          src="/images/logo-eneha.png"
          alt="Logo"
          styles={{ root: { alignSelf: 'center' } }}
        />

        {/* Título */}
        <Text variant="large" styles={{ root: { textAlign: 'center', fontWeight: 'bold' } }}>
          Registro Nacional de Instructores/as y Entrenadores/as
          {/* <Text className='mt-2' block variant="small" styles={{ root: { textAlign: 'center', color: '#666' } }}>
            {apertura ? `Temporada: ${apertura.getTemporada()?.getDescripcion()}` : 'No hay apertura vigente'}
          </Text> */}
        </Text>

        {/* Cuerpo */}
        <Stack
          grow
          tokens={bodyStackTokens}
          styles={{
            root: {
              flexGrow: 1,
              // minHeight: 300,
              // maxHeight: 300,
              // overflowY: 'auto', // Por si el contenido es largo
              // border: '1px solid #ddd',
              // borderRadius: 4,
              // padding: 10,
            },
          }}
        >

          {getBody()}
        </Stack>

        <Stack className="copyright-footer">
          <Text variant="tiny" styles={{ root: { textAlign: 'center', color: '#666' } }}>
            LarrySport - Todos los derechos reservados
          </Text>
        </Stack>
      </Stack>
    </Stack>
  );
};
